var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rightBar", staticStyle: { color: "#fff" } },
    [
      _c("v-drawer", { attrs: { direction: "right", width: "26%" } }, [
        _c(
          "div",
          {
            staticClass: "animated fadeInRightBig",
            staticStyle: { height: "100%", width: "100%" },
          },
          [_c("right-cp"), _c("right-xm")],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }